module.exports = __webpack_public_path__ + "static/img/升级页面.48dd15b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/升级页面.jpg
// module id = lPcB
// module chunks = 3